/* =========================================================
   CUSTOM "MY SERVICES" PAGE — SHARED BEHAVIOR
   - Scroll reveal (.cs-reveal)
   - Tab switching (.cs-tab-btn / .cs-offer-panel)
   - FAQ accordion (.cs-faq-item)
   Safe to include multiple times: all init functions guard
   against re-binding already-initialized elements.
   ========================================================= */
(function () {
  function initReveal() {
    var items = document.querySelectorAll('.cs-reveal:not([data-cs-reveal-bound])');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('cs-reveal--visible');
        el.setAttribute('data-cs-reveal-bound', 'true');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cs-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach(function (el) {
      el.setAttribute('data-cs-reveal-bound', 'true');
      observer.observe(el);
    });
  }

  function initTabs() {
    var groups = document.querySelectorAll('[data-cs-tabs]:not([data-cs-tabs-bound])');
    groups.forEach(function (group) {
      group.setAttribute('data-cs-tabs-bound', 'true');
      var groupId = group.getAttribute('data-cs-tabs');
      var buttons = group.querySelectorAll('.cs-tab-btn');
      var panelWrapper = document.querySelector('[data-cs-panels="' + groupId + '"]');
      if (!panelWrapper) return;
      var panels = panelWrapper.querySelectorAll('.cs-offer-panel');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-cs-tab-target');

          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          panels.forEach(function (panel) {
            if (panel.getAttribute('data-cs-tab-panel') === target) {
              panel.classList.add('is-active');
            } else {
              panel.classList.remove('is-active');
            }
          });
        });
      });
    });
  }

  function initFaq() {
    var faqItems = document.querySelectorAll('.cs-faq-item:not([data-cs-faq-bound])');
    faqItems.forEach(function (item) {
      item.setAttribute('data-cs-faq-bound', 'true');
      var question = item.querySelector('.cs-faq-item__q');
      var answer = item.querySelector('.cs-faq-item__a');
      if (!question || !answer) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close other items within the same FAQ group (optional accordion behavior)
        var parentGrid = item.closest('.cs-faq__grid');
        if (parentGrid) {
          parentGrid.querySelectorAll('.cs-faq-item.is-open').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.classList.remove('is-open');
              var openAnswer = openItem.querySelector('.cs-faq-item__a');
              if (openAnswer) openAnswer.style.maxHeight = null;
            }
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  function initVideos() {
    document.querySelectorAll('[data-cs-video-card]:not([data-cs-video-bound])').forEach(function (card) {
      card.setAttribute('data-cs-video-bound', 'true');
      var video = card.querySelector('video');
      if (!video) return;
      var autoplay = card.getAttribute('data-autoplay') === 'true';
      var btn = card.querySelector('[data-cs-sound]');

      video.addEventListener('play', function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });

      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          btn.classList.toggle('is-unmuted', !video.muted);
          if (!video.muted && video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }

      if (!video.hasAttribute('controls')) {
        card.addEventListener('click', function () {
          if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else { video.pause(); }
        });
      }

      if (autoplay && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
            else { video.pause(); }
          });
        }, { threshold: 0.35 });
        io.observe(card);
      }
    });
  }

  function initSliders() {
    document.querySelectorAll('[data-cs-slider]:not([data-cs-slider-bound])').forEach(function (root) {
      root.setAttribute('data-cs-slider-bound', 'true');
      var track = root.querySelector('[data-cs-track]');
      var controls = root.querySelector('[data-cs-controls]');
      var prev = root.querySelector('[data-cs-prev]');
      var next = root.querySelector('[data-cs-next]');
      var dotsWrap = root.querySelector('[data-cs-dots]');
      if (!track) return;
      var step = 0, pages = 1, ticking = false, timer = null, paused = false;

      function measure() {
        var first = track.children[0];
        if (!first) return;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        step = first.getBoundingClientRect().width + gap;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var overflow = maxScroll > 4;
        if (controls) controls.hidden = !overflow;
        pages = overflow ? Math.max(1, Math.round(maxScroll / step) + 1) : 1;
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < pages; i++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'cs-slider__dot';
            d.setAttribute('aria-label', 'Slide ' + (i + 1));
            (function (idx) { d.addEventListener('click', function () { go(idx); }); })(i);
            dotsWrap.appendChild(d);
          }
        }
        update();
      }
      function index() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 4) return pages - 1;
        return Math.min(pages - 1, Math.round(track.scrollLeft / step));
      }
      function update() {
        var idx = index();
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 4;
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
      }
      function go(i) {
        i = Math.max(0, Math.min(pages - 1, i));
        track.scrollTo({ left: i * step, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', measure);
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track);

      if (root.getAttribute('data-autoplay') === 'true') {
        var ms = (parseInt(root.getAttribute('data-interval'), 10) || 5) * 1000;
        ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }, { passive: true }); });
        ['mouseleave', 'focusout'].forEach(function (ev) { root.addEventListener(ev, function () { paused = false; }); });
        timer = setInterval(function () {
          if (paused || document.hidden) return;
          go(index() >= pages - 1 ? 0 : index() + 1);
        }, ms);
      }
      measure();
    });
  }

  function initAll() {
    initReveal();
    initTabs();
    initFaq();
    initVideos();
    initSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-run when Shopify theme editor adds/reorders sections/blocks
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
